@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="categorizationScoreSegments()"
            [centerLabel]="categorizationScoreCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-pie-chart
        [segments]="categorizationScoreSegments()"
        [centerLabel]="categorizationScoreCenterLabel()"
        [valueColumnHeader]="'dashboard.visuals.widgets.categorizationScore.tableLabel' | translate"
        [loading]="dataService.loading()"
        [variant]="pieChartVariantEnum.LARGE"
    />
}
